import ProductSaleTable from '@/components/sale/ProductSaleTable';
import { SalePinActionsBar } from '@/pages/sale/components/sale-pin-actions-bar';
import Grid from '@mui/material/Grid';
import { memo, useState } from 'react';

type SaleProductColumnProps = {
  productView: 'grid' | 'list';
  selectedProducts: string[];
  onToggleProductSelect: (productId: string) => void;
  isSearchOpen: boolean;
  onSearchOpenChange: (open: boolean) => void;
  scheduleVariantRefresh: (variantId: string) => void;
};

export const SaleProductColumn = memo(function SaleProductColumn({
  productView,
  selectedProducts,
  onToggleProductSelect,
  isSearchOpen,
  onSearchOpenChange,
  scheduleVariantRefresh,
}: SaleProductColumnProps) {
  const [pinWrapMode, setPinWrapMode] = useState(true);

  return (
    <Grid
      item
      xs={12}
      md={8}
      sx={{
        width: { xs: '100%', md: '66.666667%' },
        maxWidth: { xs: '100%', md: '66.666667%' },
        paddingLeft: { xs: '8px !important', md: '16px !important' },
        paddingTop: { xs: '8px !important', md: '16px !important' },
        display: 'flex',
        flexDirection: 'column',
        height: { md: 'calc(100dvh - 12rem)' },
        minHeight: 0,
      }}
    >
      <SalePinActionsBar
        pinWrapMode={pinWrapMode}
        onPinWrapModeChange={setPinWrapMode}
        onOpenSearch={() => onSearchOpenChange(true)}
      />
      <div className="flex w-full flex-1 flex-col overflow-visible md:min-h-0 md:overflow-hidden">
        <ProductSaleTable
          productView={productView}
          selectedProducts={selectedProducts}
          onToggleProductSelect={onToggleProductSelect}
          onRefresh={scheduleVariantRefresh}
          isSearchOpen={isSearchOpen}
          onSearchOpenChange={onSearchOpenChange}
          pinWrapMode={pinWrapMode}
        />
      </div>
    </Grid>
  );
});
